import $ from 'jquery';
import ChartCollection from '@/data/models/chart_collection';
import ChartModel from '@/data/models/chart';
import DataRouter from '@/data/routers/data';

window.ChartCollection = ChartCollection;
window.ChartModel = ChartModel;

$(document).ready(function () {
  // Need to change how the router operates
  window.app = new DataRouter();

  //add listener to sorter
  $('.chart-sort-by input[type="radio"]').on('click', function() {
    this.form.submit();
  });

  //add listener to per page
  $('select#per_page').on('change', function() {
    this.form.submit();
  });
});
